module.exports = __webpack_public_path__ + "static/media/copy.70f6e0ff.svg";